import React from "react";
import Navbar from "./Components/Navbar/Navbar";
import Hero from "./Components/Hero/Hero";
import Events from "./Components/Events/Events";
import Growth from "./Components/Growth/Growth";
import Footer from "./Components/Footer/Footer";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Events />
      <Growth />
      <Footer />
    </div>
  );
}

export default App;
